import { render, staticRenderFns } from "./TensionsCard.vue?vue&type=template&id=4fc5266c&"
import script from "./TensionsCard.vue?vue&type=script&lang=js&"
export * from "./TensionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports